/**
 * 通用打点工具
 */
const __commonParams = {}

/**
 * 用于注册后续需要使用的通用上报参数
 * @param {object} keyValues
 */
export function registerCommonParams(keyValues = {}) {
  Object.assign(__commonParams, keyValues)
}

/**
 * 调用黄金令箭进行打点
 * @param {string} logkey 黄金令箭Key
 * @param {string} logtype CLK | EXP | OTHER
 * @param {object} params 要上报的参数对
 * @param {boolean} shouldAddCommonParams 是否需要将公共的参数添加入打点
 */
export function dot(logkey, logtype, params, shouldAddCommonParams = false) {
  const resultParams = {}
  if (shouldAddCommonParams) {
    Object.assign(resultParams, __commonParams)
  }

  Object.assign(resultParams, params)

  let recordStr = ''
  const recordArr = []
  // eslint-disable-next-line
  Object.keys(resultParams).forEach(key => {
    const value = resultParams[key]
    if (!(value === undefined || value === null)) {
      recordArr.push(`${key}=${encodeURIComponent(value)}`)
    }
  })
  recordStr = recordArr.join('&')

  if (window.goldlog) {
    window.goldlog.record(logkey, logtype, recordStr)
  } else {
    if (!window.goldlog_queue) {
      window.goldlog_queue = []
    }

    window.goldlog_queue.push({
      action: 'goldlog.record',
      arguments: [logkey, logtype, recordStr],
    })
  }
}

export function setParamsFromBeconAplusScriptAndReport(kv, callback) {
  const el = document.getElementById('beacon-aplus')
  if (!el) return false

  const exparams = el.getAttribute('exparams') || ''
  // exparams decode
  const target = []
  let newExparams = ''
  exparams.replace(/([^=&]+)\s*(?:=(\s*[^&]*))?(&|$)/g, (_, key, value) => {
    if (kv[key]) {
      value = kv[key]
    }
    target.push([key, value])

    return ``
  })
  newExparams = target
    .map(([k, v]) => `${encodeURIComponent(k)}=${v}`)
    .join('&')

  el.setAttribute('exparams', newExparams)

  setTimeout(() => {
    callback()
  })
  return true
}
